import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './BarTender.frontend.types'

@Injectable({ providedIn: 'root' })
export class BarTender_azure_blob_storage_upload_file_string_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { file_path: string, file_name: string, file_content: string, file_type: string }): Promise<{ reasons?: string[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.file_path)) {
      missingRequiredInParams.push('\'file_path\'');
    }
    if (isNil(inParams.file_name)) {
      missingRequiredInParams.push('\'file_name\'');
    }
    if (isNil(inParams.file_content)) {
      missingRequiredInParams.push('\'file_content\'');
    }
    if (isNil(inParams.file_type)) {
      missingRequiredInParams.push('\'file_type\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/BarTender/functions/azure_blob_storage_upload_file_string_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

